import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTheme } from '../../context/ThemeContext';
import { Box, Button } from '@mui/material';

const AuthTabs = () => {
  const { theme } = useTheme();
  const location = useLocation();
  const isLogin = location.pathname === '/login';

  return (
    <Box
      sx={{
        display: 'flex',
        width: '100%',
        mb: 4,
        borderBottom: 1,
        borderColor: theme === 'dark' ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.1)',
      }}
    >
      <Button
        component={Link}
        to="/login"
        fullWidth
        sx={{
          py: 2,
          textTransform: 'none',
          color: isLogin 
            ? (theme === 'dark' ? '#87cefa' : '#2791d2')
            : (theme === 'dark' ? 'rgba(255, 255, 255, 0.7)' : 'rgba(0, 0, 0, 0.6)'),
          borderBottom: 2,
          borderColor: isLogin 
            ? (theme === 'dark' ? '#87cefa' : '#2791d2')
            : 'transparent',
          borderRadius: 0,
          '&:hover': {
            background: 'transparent',
            color: theme === 'dark' ? '#87cefa' : '#2791d2',
          },
        }}
      >
        Login
      </Button>
      <Button
        component={Link}
        to="/signup"
        fullWidth
        sx={{
          py: 2,
          textTransform: 'none',
          color: !isLogin 
            ? (theme === 'dark' ? '#87cefa' : '#2791d2')
            : (theme === 'dark' ? 'rgba(255, 255, 255, 0.7)' : 'rgba(0, 0, 0, 0.6)'),
          borderBottom: 2,
          borderColor: !isLogin 
            ? (theme === 'dark' ? '#87cefa' : '#2791d2')
            : 'transparent',
          borderRadius: 0,
          '&:hover': {
            background: 'transparent',
            color: theme === 'dark' ? '#87cefa' : '#2791d2',
          },
        }}
      >
        Sign Up
      </Button>
    </Box>
  );
};

export default AuthTabs; 